import { FieldContent, ExtendedErrorId, setCustomValidator, Validator } from '@sheerid/jslib';
import { ClassIDEnum } from '../types/runtimeTypes';

const isValidClassId = (value: string) => {
    const validClassIds: ClassIDEnum[] = Object.values(ClassIDEnum);
    if (validClassIds.indexOf(value as ClassIDEnum) >= 0) {
        return true;
    }
    return false;
};

export const addMajorValidator = () => {
    const invalidMajor: ExtendedErrorId = 'invalidMajor';

    const getMajorValidationError: Validator = (value: FieldContent): ExtendedErrorId | undefined => {
        if (value && !isValidClassId(value as string)) {
            return invalidMajor;
        }
        return;
    };
    setCustomValidator('major', getMajorValidationError);
};

export const addMinorValidator = () => {
    const invalidMinor: ExtendedErrorId = 'invalidMinor';

    const getMinorValidationError: Validator = (value: FieldContent): ExtendedErrorId | undefined => {
        if (value && !isValidClassId(value as string)) {
            return invalidMinor;
        }
        return;
    };
    setCustomValidator('minor', getMinorValidationError);
};
